module.exports = __webpack_public_path__ + "img/Tuvalu.be5919c3.svg";